export const FIREBASE_ACCESS_TOKEN_KEY = 'pfjwt';
export const APP_ACCESS_TOKEN_KEY = 'pjwt';
